import { DonutChart } from "@/components/DonutChart";

export function StatusDonut({ byStatus }) {
  const data = Object.entries(byStatus).map(([k, v]) => ({ name: k.replace("_", " "), value: v }));
  return <DonutChart data={data} testId="status-donut" />;
}
